import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { AssistanceCase } from 'src/app/models/assistancecase';
import { TranslateService } from '@ngx-translate/core';
import { AssistanceTicket } from 'src/app/models/assistanceticket';
import { ApiService } from 'src/app/api/api.service';
import { State } from 'src/app/models/state';
import * as _ from 'lodash';
import { SelectLocationComponent } from 'src/app/components/select-location/select-location.component';
import { LoaderService } from '../../../../api/loader.service';
import { MessageService } from 'primeng/api';

export class Location {
  latitude: number;
  longitude: number;
}
@Component({
    selector: 'app-case-form',
    templateUrl: './case-form.component.html',
    styleUrls: ['./case-form.component.css'],
    standalone: false
})
export class CaseFormComponent implements OnInit, OnChanges {
  @Output() update = new EventEmitter<AssistanceTicket>();
  eventLocation = new EventEmitter<any>();
  @Input() assistancecase: AssistanceCase;
  @Input() latitude: any;
  @Input() longitude: any;
  @Input() states: any[];
  @Input() isTiketInfo: boolean;
  statesDistrict: any[];
  editticket: AssistanceTicket;
  statesDistrictTicket: any[];
  area_destination: string;
  zone_destination: number;
  caseLocation: any = {};
  @Input() editevent: EventEmitter<void>;
  stateLocation = new EventEmitter<any>();
  state: State;
  stateId: number;
  showMap = new EventEmitter<boolean>();
  editLocation: Location;
  loaderLocation: boolean = false;
  @ViewChild('form') caseForm;
  enableEditing = false;
  @ViewChild('selectLocationComp')
  selectLocationComponent: SelectLocationComponent;

  google_address_origen: String = '';
  google_address_destination: String = '';


  countries: any[];
  statesTicket: any[];
  memberLocationDestination = new EventEmitter<any>();


  //---validar latitude longitud
  have_coordinates=true;
  msgs: any[] = [];
  @Input() visible: boolean;
  constructor(
    private translate: TranslateService,
    private api: ApiService,
    private loaderService: LoaderService,
    private messageService: MessageService
  ) {
    this.editLocation = new Location();
  }

  ngOnInit(): void {
    this.assistancecase = new AssistanceCase();
    this.editticket = new AssistanceTicket();
    this.resetTicketStates()

    if (this.editevent) {
      this.editevent.subscribe((rep) => {
        this.onSelectCase();
        this.msgs=[]
       
        this.setCoordinates(this.latitude,this.longitude)
      });
    }

    this.api.countries
      .get()
      .promise()
      .then((countries) => {
        this.countries = countries.data;
      });
  }


  ngOnChanges(changes: SimpleChanges) {

    
    if (changes['latitude']) {
        this.setCoordinates(changes['latitude'].currentValue ,changes['longitude'].currentValue )
    }

  }
  
  setCoordinates(latitude,longitud){

    if(latitude != undefined && longitud!=null && longitud!=0){
      this.have_coordinates=true;
      this.msgs = [
        { severity: 'success', summary: '', detail: 'Geolocalización recibida' }
      ];

   

    }else{
      this.have_coordinates=false;
  
      this.msgs = [
        { severity: 'error', summary: '', detail: 'El caso no tiene ubicación' }
      ];
    }


    this.caseLocation = {
      latitude: latitude ,
      longitude: longitud,
    };

  }
  onSelectLocation(location) {
    this.loaderLocation = false;
    this.editLocation.latitude = location.latitude;
    this.editLocation.longitude = location.longitude;

    const coordinates = {
      latitude: location.latitude,
      longitude: location.longitude,
    };

    this.api.assistancecases
      .get_geolocation_by_coordinates(coordinates)
      .post()
      .promise()
      .then((resp) => {
        setTimeout(() => {
          if (resp.result) {
            this.google_address_origen = resp.complete_address;
            this.assistancecase.area = resp.mayoralty;
            this.assistancecase.suburb = resp.neighborhood;
            this.assistancecase.street = resp.street_number;
            this.assistancecase.postal_code = resp.postal_code;
            this.assistancecase.reference = resp.reference;
            this.assistancecase.state_id = resp.state_id;
            this.assistancecase.state_district_id = resp.district_id;

            if (this.assistancecase.state_id) {
              this.onSelectState(this.assistancecase.state_id);
            }

            if (
              this.caseForm &&
              this.caseForm.form &&
              this.caseForm.form.controls
            ) {
              this.caseForm.form.controls.area.patchValue(resp.mayoralty);
              this.caseForm.form.controls.suburb.patchValue(resp.neighborhood);
              this.caseForm.form.controls.street.patchValue(resp.street_number);
              this.caseForm.form.controls.postal_code.patchValue(
                resp.postal_code
              );
              this.caseForm.form.controls.reference.patchValue(resp.reference);
            }
          }
        }, 1);
      })
      .catch((e) => {
        this.createCurrentAddress();
      });
  }

  step1SetLocation(location) {
    this.editticket.latitude = location.latitude;
    this.editticket.longitude = location.longitude;

    const coordinates = {
      latitude: location.latitude,
      longitude: location.longitude,
    };

    this.api.assistancecases
      .get_geolocation_by_coordinates(coordinates)
      .post()
      .promise()
      .then((resp) => {
        setTimeout(() => {
          if (resp.result) {
            this.google_address_destination = resp.complete_address;
            this.editticket.area_destination = resp.mayoralty;
            this.editticket.suburb_destination = resp.neighborhood;
            this.editticket.street_destination = resp.street_number;
            this.editticket.postal_code_destination = resp.postal_code;
            this.editticket.state_id = resp.state_id;
            this.editticket.state_area_id = resp.district_id;

            if (this.editticket.state_id) {
              this.onSelectStateTicket(this.editticket.state_id);
            }

            if (
              this.caseForm &&
              this.caseForm.form &&
              this.caseForm.form.controls
            ) {
              this.caseForm.form.controls.suburb_destination.patchValue(
                resp.neighborhood
              );
              this.caseForm.form.controls.street_destination.patchValue(
                resp.street_number
              );
              this.caseForm.form.controls.postal_code_destination.patchValue(
                resp.postal_code
              );
            }
          }
        }, 1);
      })
      .catch((e) => {
        this.createAddressDestination();
      });
  }

  createCurrentAddress() {
    if (!this.assistancecase.address) {
      this.assistancecase.address = `${this.assistancecase.area || ''} ${
        this.assistancecase.postal_code || ''
      } ${this.assistancecase.street || ''} ${this.assistancecase.zone || ''} ${
        this.assistancecase.suburb || ''
      }`;
    }
  }

  createAddressDestination() {
    if (!this.editticket.address_destination) {
      this.editticket.address_destination = `${
        this.editticket.area_destination || ''
      } ${this.editticket.postal_code_destination || ''} ${
        this.editticket.street_destination || ''
      } ${this.editticket.zone_destination || ''} ${
        this.editticket.suburb_destination || ''
      }`;
    }
  }

  onSelectState(state_id) {
    if (state_id) {
      this.assistancecase.state_id = state_id;
      this.stateId = state_id;

      this.state = _.find(this.states, function (s) {
        return s.id === state_id;
      });
      this.emitStateLocation();
      const filter = { state_id: state_id };
      this.api.statedistricts
        .get()
        .filter(filter)
        .promise()
        .then((d) => {
          this.statesDistrict = d.data;
        });
    } else {
      this.statesDistrict = [];
      this.assistancecase.state_district_id = null;
    }
  }
  // use case
  onSelectStateDistrict(event) {}

  onSelectStateTicket(state_id) {
    this.editticket.state_area_id = null;

    if (state_id) {
      const filter = { state_id: state_id };
      this.api.statedistricts
        .get()
        .filter(filter)
        .promise()
        .then((d) => {
          this.statesDistrictTicket = d.data;
        });
    } else {
      this.statesDistrictTicket = [];
    }
  }

  emitStateLocation() {
    if (
      this.state &&
      this.state.latitude != null &&
      this.state.longitude != null
    ) {
      const statelocation = {
        latitude: this.state.latitude,
        longitude: this.state.longitude,
      };
      this.stateLocation.emit(statelocation);
    }
  }

  onSelectCase(): void {
    if (!this.assistancecase.origin_country_id) {
      this.assistancecase.origin_country_id = this.assistancecase.country_id;
    }

    if (!this.assistancecase.destination_country_id) {
      this.assistancecase.destination_country_id =
        this.assistancecase.country_id;
    }

    this.api.states
      .get(this.assistancecase.origin_country_id)
      .promise()
      .then((states) => {
        this.states = states;
        const filter = {
          state_id: this.assistancecase.state_id,
        };
        this.api.statedistricts
          .get()
          .filter(filter)
          .promise()
          .then((d) => {
            this.statesDistrict = d.data;
          });
      });

    let filter = { case_id: this.assistancecase.id, ticket_type: 1 };

    this.api.assistancetickets
      .get()
      .all()
      .filter(filter)
      .sort('id', true)
      .promise()
      .then((response) => {
        this.editticket = response.data[0];

        if (this.editticket.latitude && this.editticket.longitude) {
          this.caseLocation = {
            latitude: this.editticket.latitude,
            longitude: this.editticket.longitude,
          };

          this.eventLocation.emit(this.caseLocation);
        } else {
          this.setLocationCountry(this.assistancecase.destination_country_id? this.assistancecase.destination_country_id : this.assistancecase.country_id);
        }

        const filter = { state_id: this.editticket.state_id };

        this.api.states
          .get(
            this.assistancecase.destination_country_id
              ? this.assistancecase.destination_country_id
              : this.assistancecase.country_id
          )
          .promise()
          .then((states) => {
            this.statesTicket = states;
            this.api.statedistricts
              .get()
              .filter(filter)
              .promise()
              .then((d) => {
                this.statesDistrictTicket = d.data;
              });
          });
      });
  }

  saveAsistanceTicket() {
    this.loaderService.display(true);

    if (this.google_address_origen != '') {
      this.assistancecase.address =
        this.assistancecase.address + ` (${this.google_address_origen})`;
      if (this.caseForm && this.caseForm.form && this.caseForm.form.controls)
        this.caseForm.form.controls.address.patchValue(
          this.assistancecase.address
        );
    }
    if (this.google_address_destination != '') {
      this.editticket.address_destination =
        this.editticket.address_destination +
        ` (${this.google_address_destination})`;
      if (this.caseForm && this.caseForm.form && this.caseForm.form.controls) {
        this.caseForm.form.controls.address_destination.patchValue(
          this.editticket.address_destination
        );
      }
    }

    this.api.assistancetickets
      .update(this.editticket, this.editticket.id)
      .promise()
      .then((ticket) => {
        this.loaderService.display(false);
        this.update.emit(ticket);
        this.translate
          .get('Assistance ticket updated')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: `${res}: ${ticket.id}`,
            });
          });
      })
      .catch((e) => {
        this.loaderService.display(true);
        this.translate
          .get('Error updating assistance ticket')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.error}`,
            });
          });
      });
  }

  onSelectCountryDestination(country_id: number) {
    this.resetTicketStates();

    if (!country_id) {
      return;
    }

    this.api.states
      .get(country_id)
      .promise()
      .then((states) => {
        this.statesTicket = states;
      })
      .catch((e) => {
        console.error('Error fetching states:', e);
      });

    this.setLocationCountry(country_id);
  }

  private resetTicketStates(): void {
    this.statesTicket = [];
    this.editticket.state_id = null;
    this.statesDistrictTicket = [];
    this.editticket.state_area_id = null;
  }

  private setLocationCountry(country_id: number): void {
    if (!country_id) {
      return;
    }

    let country = _.find(this.countries, function (c) {
      return c.id === country_id;
    });

    if (country.locale.length > 2) {
      country.locale = country.locale.split('-')[1].toLowerCase();
    }

    let country_code: any = {
      country_name: '',
      country_local: '',
      iso3166_1: '',
    };

    country_code.country_name = country.name;
    country_code.country_local = country.locale;
    country_code.iso3166_1 = country.iso3166_1;

    this.caseLocation = {
      latitude: null,
      longitude: null,
    };
    this.memberLocationDestination.emit(country_code);
  }



  openLinkLocationCustomer(event) {
    event.preventDefault()
    let url = `https://www.google.com/maps/place/${this.latitude},${this.longitude}`;
    this.api.copyToClipboard(url);
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Link de la localización del cliente copiado al portapapeles.',
    });
    // window.open(url, "_blank");
  }



}
